import emptyTransactions from '@/assets/lotties/empty_state.json';
import loadingError from '@/assets/lotties/payment_failure.json';

export const EVENTS = {
  TRANSACTIONS: {
    LIST_ALL: {
      REFRESH: 'TRANSACTIONS.LIST_ALL.REFRESH',
      REFRESHING: 'TRANSACTIONS.LIST_ALL.REFRESHING',
      REFRESHED: 'TRANSACTIONS.LIST_ALL.REFRESHED',
      REFRESH_ERROR: 'TRANSACTIONS.LIST_ALL.REFRESH_ERROR'
    },
    DETAIL: {
      SHOW: 'transaction.detail.show',
      REFRESHING: 'transactions.detail.refreshing',
      REFRESH_ERROR: 'transactions.detail.refresh_error',
      REFRESHED: 'transactions.detail.refreshed'
    }
  }
};

export const ENDPOINTS = {
  TRANSACTIONS: {
    GET_LIST:
      '/onebpay-transactions/list?userId={userId}&limit=300&group=lacasae'
  }
};

export const TRANSACTIONS = {
  LOTTIES: {
    EMPTY: emptyTransactions,
    LOADING_ERROR: loadingError
  },

  SERVICES_LIST: [
    {
      id: '1xbet',
      name: '1xBet',
      bookmaker: '1xBet',
      description: 'Recharges & Retraits',
      descriptionLarge: 'Recharges & Retraits',
      logo: '/images/services/1xBetIco.svg',
      bannerImage: '/images/services/1xBetIco.svg',
      idFindingMockup: '/images/screenshots/1xbet-account-id-getting.webp',
      color: '#002E5E',
      isAvailable: true,
      isDarkBg: true,
      group: 'recharges'
    },
    {
      id: 'betwinner',
      name: 'Betwinner',
      bookmaker: 'Betwinner',
      description: 'Recharges & Retraits',
      descriptionLarge: 'Recharges & Retraits',
      logo: '/images/services/betwinner-full.png',
      bannerImage: '/images/services/betwinner-full.png',
      idFindingMockup: '/images/screenshots/betwinner-account-id-getting.webp',
      color: '#1F7E5C',
      isAvailable: true,
      isDarkBg: true,
      group: 'recharges'
    },
    {
      id: '1win',
      name: '1Win',
      bookmaker: '1Win',
      description: 'Recharges & Retraits',
      descriptionLarge: 'Recharges & Retraits',
      logo: '/images/services/1winIcon.svg',
      bannerImage: '/images/services/1winIcon.svg',
      idFindingMockup: '/images/screenshots/1win-account-id-getting.webp',
      color: '#080E1E',
      isAvailable: true,
      isDarkBg: true,
      group: 'recharges'
    },
    {
      id: 'eightStarz',
      name: '888Starz',
      bookmaker: '888Starz',
      description: 'Recharges & Retraits',
      descriptionLarge: 'Recharges & Retraits',
      logo: '/images/services/eightStarz.png',
      bannerImage: '/images/services/eightStarz.png',
      idFindingMockup: '/images/screenshots/eightStarz-account-id-getting.webp',
      color: '#771512',
      isAvailable: true,
      onlyGa: true,
      isDarkBg: true,
      group: 'recharges'
    },
    {
      id: 'melbet',
      name: 'Melbet',
      bookmaker: 'Melbet',
      description: 'Recharges & Retraits',
      descriptionLarge: 'Recharges & Retraits',
      logo: '/images/services/melbetIcon.svg',
      bannerImage: '/images/services/melbetIcon.svg',
      idFindingMockup: '/images/screenshots/melbet-account-id-getting.png',
      color: '#272727',
      isAvailable: true,
      isDarkBg: true,
      group: 'recharges'
    },
    // {
    //   id: 'giftCard',
    //   name: 'Cartes Cadeaux',
    //   description: 'Achat & Vente',
    //   descriptionLarge: 'Achat & Vente',
    //   logo: '/images/services/gift-card.svg',
    //   bannerImage: '/images/services/gift-card.svg',
    //   color: '#e76f51',
    //   isAvailable: true,
    //   isDarkBg: false,
    //   group: 'others',
    // },
    {
      id: 'usdt',
      name: 'USDT',
      description: 'Achat & Vente',
      descriptionLarge: 'Achat & Vente',
      logo: '/images/services/usdtIcon.svg',
      bannerImage: '/images/services/usdtIcon.svg',
      color: '#55AD94',
      isAvailable: true,
      isDarkBg: false,
      group: 'trade'
    },
    // {
    //   id: 'subscription',
    //   name: 'Abonnements',
    //   description: 'Vos abonnements facile',
    //   descriptionLarge: 'Vos abonnements facile',
    //   logo: '/images/services/sabonner.png',
    //   bannerImage: '/images/services/sabonner.png',
    //   color: '#354E92',
    //   isAvailable: true,
    //   isDarkBg: true,
    //   notAvailableMessage:
    //     'La commande de repas est bientot disponible chez vous',
    //   group: 'others',
    // },
    ...[
      {
        name: 'Netflix',
        icon: '/images/services/netflix.svg',
        url: 'https://store.kingrecharges.com/produit/?id=netflix12345'
      },
      {
        name: 'PrimeVideo',
        icon: '/images/services/prime-video.svg',
        url: 'https://store.kingrecharges.com/produit/?id=primevideo67890'
      },
      {
        name: 'Disney',
        icon: '/images/services/disney-plus.svg',
        url: 'https://store.kingrecharges.com/produit/?id=disneyplus54321'
      },
      {
        name: 'Crunchyrol',
        icon: '/images/services/crunchyroll.svg',
        url: 'https://store.kingrecharges.com/produit/?id=crunchyroll98765'
      },
      {
        name: 'Spotify',
        icon: '/images/services/spotify.svg',
        url: 'https://store.kingrecharges.com/produit/?id=spotify12345'
      },
      {
        name: 'NordVPN',
        icon: '/images/services/nordvpn.svg',
        url: 'https://store.kingrecharges.com/produit/?id=nordvpn67890'
      },
      {
        name: 'PrivateVPN',
        icon: '/images/services/privatevpn.png',
        url: 'https://store.kingrecharges.com/produit/?id=privatevpn54321'
      },
      {
        name: 'CyberGhost',
        icon: '/images/services/cyberghost.webp',
        url: 'https://store.kingrecharges.com/produit/?id=cyberghost98765'
      },
      {
        name: 'Adn',
        icon: '/images/services/adn.svg',
        url: 'https://store.kingrecharges.com/produit/?id=adn12345'
      }
    ].map((el) => {
      return {
        id: el.name,
        name: el.name,
        description: `Abonnement ${el.name}`,
        descriptionLarge: `Abonnement ${el.name}`,
        logo: el.icon,
        color: '#55AD94',
        group: 'others',
        options: [
          {
            serviceId: el.name,
            id: 'subscription',
            title: `Abonnement ${el.name}`,
            description: `Lancer votres abonnement ${el.name}`,
            smallDescription: `Lancer votres abonnement ${el.name}`,
            url: el.url || 'https://store.kingrecharges.com/'
          }
        ]
      };
    })
  ],
  SERVICES_OPTIONS: {
    '1xbet': [
      {
        serviceId: '1xbet',
        id: 'fund',
        title: 'Recharge 1xbet',
        description: 'Déposez rapidement sur votre compte 1xBet.',
        smallDescription: 'Lancez un dépot instantané'
      },
      {
        serviceId: '1xbet',
        id: 'withdraw',
        title: 'Retrait 1xbet',
        description: 'Retirez vos fonds 1xBet simplement.',
        smallDescription: 'Retirez vos gains'
      }
    ],

    '1win': [
      {
        serviceId: '1win',
        id: 'fund',
        title: 'Recharge 1win',
        description: 'Déposez rapidement sur votre compte 1Win.',
        smallDescription: 'Lancez un dépot instantané'
      },
      {
        serviceId: '1win',
        id: 'withdraw',
        title: 'Retrait 1win',
        description: 'Retirez vos fonds 1Win simplement.',
        smallDescription: 'Retirez vos gains'
      }
    ],

    betwinner: [
      {
        serviceId: 'betwinner',
        id: 'fund',
        title: 'Recharge betwinner',
        description: 'Déposez rapidement sur votre compte BetWinner.',
        smallDescription: 'Lancez un dépot instantané'
      },
      {
        serviceId: 'betwinner',
        id: 'withdraw',
        title: 'Retrait betwinner',
        description: 'Retirez vos fonds BetWinner simplement.',
        smallDescription: 'Retirez vos gains'
      }
    ],

    melbet: [
      {
        serviceId: 'melbet',
        id: 'fund',
        title: 'Recharge melbet',
        description: 'Déposez rapidement sur votre compte MelBet.',
        smallDescription: 'Lancez un dépot instantané'
      },
      {
        serviceId: 'melbet',
        id: 'withdraw',
        title: 'Retrait melbet',
        description: 'Retirez vos fonds MelBet simplement.',
        smallDescription: 'Retirez vos gains'
      }
    ],

    eightStarz: [
      {
        serviceId: 'eightStarz',
        id: 'fund',
        title: 'Recharge 888Starz',
        description: 'Déposez rapidement sur votre compte 8Starz.',
        smallDescription: 'Lancez un dépot instantané'
      },
      {
        serviceId: 'eightStarz',
        id: 'withdraw',
        title: 'Retrait 888Starz',
        description: 'Retirez vos fonds 8Starz simplement.',
        smallDescription: 'Retirez vos gains'
      }
    ],

    pm: [
      {
        serviceId: 'pm',
        id: 'buy',
        title: 'Achat PM',
        description: 'Achetez du Perfect Money rapidement.',
        smallDescription: 'Achat rapide'
      },
      {
        serviceId: 'pm',
        id: 'sell',
        title: 'Vente PM',
        description: 'Vendez votre Perfect Money facilement.',
        smallDescription: 'Vente rapide'
      }
    ],

    usdt: [
      {
        serviceId: 'usdt',
        id: 'buy',
        title: 'Achat USDT',
        description: 'Achetez du USDT rapidement.',
        smallDescription: 'Achat rapide'
      },
      {
        serviceId: 'usdt',
        id: 'sell',
        title: 'Vente USDT',
        description: 'Vendez votre USDT facilement.',
        smallDescription: 'Vente rapide'
      }
    ],

    wallet: [
      {
        serviceId: 'wallet',
        id: 'fund',
        title: 'Recharge Wallet',
        description: 'Déposez rapidement sur votre portefeuille.',
        smallDescription: 'Recharge rapide'
      },
      {
        serviceId: 'wallet',
        id: 'withdraw',
        title: 'Retrait Wallet',
        description: 'Retirez vos fonds simplement.',
        smallDescription: 'Retrait rapide'
      }
    ],

    giftCard: [
      {
        serviceId: 'giftCard',
        id: 'buy',
        title: 'Achat Gift Card',
        description: 'Achetez des Gift Cards rapidement.',
        smallDescription: 'Achat rapide'
      },
      {
        serviceId: 'giftCard',
        id: 'sell',
        title: 'Vente Gift Card',
        description: 'Vendez vos Gift Cards facilement.',
        smallDescription: 'Vente rapide'
      }
    ]
  }
};
